import React, { useState, useEffect } from "react";
import "../css/home.css";
import image1 from "../images/image9.jpeg";
import image2 from "../images/image2.jpeg";
import image3 from "../images/image13.jpeg";
import image4 from "../images/image3.jpeg";
import image5 from "../images/image5.jpeg";
import logo from "../images/logo.svg";

const Home = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      id: 1,
      title: "Boiler Servicing & Diagnostics",
      desc: "Comprehensive internal maintenance and precise fault-finding for integrated boiler units.",
      image: image1,
    },
    {
      id: 2,
      title: "Premium Boiler Installations",
      desc: "High-efficiency Worcester system upgrades featuring flawlessly routed copper pipework.",
      image: image2,
    },
    {
      id: 3,
      title: "Clean Pipework & Filtration",
      desc: "Professional wall-mounted installations featuring magnetic system filters for extended boiler lifespan.",
      image: image3,
    },
    {
      id: 4,
      title: "System Retrofits",
      desc: "Seamless integration of modern boilers and magnetic filtration systems into your existing heating setup.",
      image: image4,
    },
    {
      id: 5,
      title: "Unvented Cylinder Systems",
      desc: "High-capacity stainless steel hot water cylinder installations for superior mains-pressure hot water.",
      image: image5,
    },
  ];

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // --- FORM 1: HERO FORM ---
  const [heroForm, setHeroForm] = useState({ name: "", phone: "" });
  const [isSubmittingHero, setIsSubmittingHero] = useState(false);
  const [heroSuccess, setHeroSuccess] = useState(false);
  const [submittedHeroName, setSubmittedHeroName] = useState("");

  const handleHeroSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingHero(true);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "c2f63c9b-0675-4b4a-ad80-75f5166f7f0c",
          subject: `Quick Call Request from ${heroForm.name}`,
          from_name: "Harveys Gas and Plumbing Website",
          ...heroForm,
        }),
      });

      if (response.ok) {
        setSubmittedHeroName(heroForm.name);
        setHeroSuccess(true);
        setHeroForm({ name: "", phone: "" });
      } else {
        alert("Oops! Something went wrong.");
      }
    } catch (error) {
      alert("Network error. Please try again.");
    } finally {
      setIsSubmittingHero(false);
    }
  };

  // --- FORM 2: DETAILED CONTACT FORM ---
  const [contactForm, setContactForm] = useState({
    name: "",
    phone: "",
    service: "Plumbing",
    message: "",
  });
  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [contactSuccess, setContactSuccess] = useState(false);
  const [submittedContactName, setSubmittedContactName] = useState("");

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingContact(true);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "c2f63c9b-0675-4b4a-ad80-75f5166f7f0c",
          subject: `Detailed Lead: ${contactForm.service} Request from ${contactForm.name}`,
          from_name: "Harveys Gas and Plumbing Website",
          ...contactForm,
        }),
      });

      if (response.ok) {
        setSubmittedContactName(contactForm.name);
        setContactSuccess(true);
        setContactForm({
          name: "",
          phone: "",
          service: "Plumbing",
          message: "",
        });
      } else {
        alert("Oops! Something went wrong.");
      }
    } catch (error) {
      alert("Network error. Please try again.");
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const [openFaq, setOpenFaq] = useState(null);
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "What should I do in a plumbing or gas emergency?",
      answer: "For water leaks, immediately locate your internal stopcock...",
    },
    {
      question: "Do you charge a call-out fee and how does your pricing work?",
      answer: "We believe in 100% transparent pricing...",
    },
    {
      question: "How often should my boiler be serviced?",
      answer: "Your boiler should be serviced annually...",
    },
    {
      question: "Do you provide guarantees on your work?",
      answer: "Yes. We pride ourselves on precision engineering...",
    },
    {
      question: "What is a Power Flush and do I need one?",
      answer: "A power flush is a deep clean of your heating system...",
    },
    {
      question: "What areas do you cover?",
      answer:
        "We are based in Birmingham and serve the entire surrounding region...",
    },
    {
      question: "Can you fix a boiler instead of replacing it?",
      answer: "We are expert fault-finders...",
    },
  ];

  return (
    <div className="app-container">
      {/* Glassmorphic Navigation */}
      <nav className="navbar">
        <div className="nav-brand">
          <a href="#home" onClick={closeMobileMenu}>
            <img src={logo} alt="LH Gas and Plumbing Logo" />
          </a>
        </div>

        <div
          className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}
          onClick={toggleMobileMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <ul className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
          <li>
            <a href="#home" onClick={closeMobileMenu}>
              Home
            </a>
          </li>
          <li>
            <a href="#portfolio" onClick={closeMobileMenu}>
              Projects
            </a>
          </li>
          <li>
            <a href="#about" onClick={closeMobileMenu}>
              About Us
            </a>
          </li>
          <li>
            <a href="#faq" onClick={closeMobileMenu}>
              FAQ
            </a>
          </li>
          <li>
            <a href="#contact" onClick={closeMobileMenu}>
              Contact
            </a>
          </li>
        </ul>
      </nav>

      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <div className="hero-badges">
            <span className="badge">Gas Safe Registered</span>
            <span className="badge">24/7 Emergency</span>
          </div>
          <h1>Premium Plumbing & Gas Solutions</h1>
          <p>
            Reliable, certified, and precise. We handle everything from
            emergency leaks to full heating system installations with unmatched
            professional care.
          </p>
          <div className="hero-actions">
            <a href="tel:07540487647" className="btn-secondary">
              📞 Call 07540487647
            </a>
          </div>
        </div>

        {/* HERO FORM OR SUCCESS MESSAGE */}
        <div className="hero-form-wrapper">
          <div className="hero-form">
            {heroSuccess ? (
              <div className="inline-success">
                <div className="success-icon">&#10003;</div>
                <h3>Request Received!</h3>
                <p>
                  Thanks {submittedHeroName}, we've received your details and
                  will call you back shortly.
                </p>
                <button
                  className="btn-secondary"
                  onClick={() => setHeroSuccess(false)}
                  style={{ borderColor: "#cbd5e1", color: "#0f172a" }}
                >
                  Send another request
                </button>
              </div>
            ) : (
              <form onSubmit={handleHeroSubmit}>
                <h3>Request a Callback</h3>
                <p>Enter your details and we'll call you right back.</p>

                <div className="input-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={heroForm.name}
                    onChange={(e) =>
                      setHeroForm({ ...heroForm, name: e.target.value })
                    }
                    placeholder="John Doe"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    value={heroForm.phone}
                    onChange={(e) =>
                      setHeroForm({ ...heroForm, phone: e.target.value })
                    }
                    placeholder="07700 900077"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn-primary"
                  disabled={isSubmittingHero}
                >
                  {isSubmittingHero ? "Sending..." : "Call Me Back"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="portfolio" id="portfolio">
        <div className="section-header">
          <h2>Featured Projects</h2>
          <p>Precision engineering and impeccably clean installations.</p>
        </div>
        <div className="slideshow-container">
          <div
            className="slides-wrapper"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide) => (
              <div className="slide" key={slide.id}>
                <div className="slide-image">
                  <div
                    className="slide-bg"
                    style={{ backgroundImage: `url(${slide.image})` }}
                  ></div>
                </div>
                <div className="slide-content">
                  <h4>{slide.title}</h4>
                  <p>{slide.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="slideshow-controls">
            <button className="control-btn" onClick={prevSlide}>
              &#8592;
            </button>
            <button className="control-btn" onClick={nextSlide}>
              &#8594;
            </button>
          </div>
        </div>
      </section>

      {/* Dynamic About Section */}
      <section className="about" id="about">
        <div className="about-content">
          <h2>Setting the Standard</h2>
          <p>
            With over 15 years of industry experience, Harveys Gas and Plumbing
            has built a reputation on reliability, transparency, and superior
            workmanship.
          </p>
          <p>
            Our team is fully certified, insured, and committed to leaving your
            property cleaner than we found it. We don't just fix problems; we
            engineer lasting solutions.
          </p>
        </div>
        <div className="about-stats">
          <div className="stat">
            <h3>15+</h3>
            <span>Years Experience</span>
          </div>
          <div className="stat" style={{ marginTop: "2.5rem" }}>
            <h3>500+</h3>
            <span>Projects Completed</span>
          </div>
          <div className="stat">
            <h3>24/7</h3>
            <span>Emergency Response</span>
          </div>
          <div className="stat" style={{ marginTop: "2.5rem" }}>
            <h3>100%</h3>
            <span>Client Satisfaction</span>
          </div>
        </div>
      </section>

      {/* Comprehensive FAQ Section */}
      <section className="faq-section" id="faq">
        <div className="section-header">
          <h2>Frequently Asked Questions</h2>
          <p>
            Everything you need to know about our services, pricing, and
            emergency procedures.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${openFaq === index ? "active" : ""}`}
              key={index}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question">
                <h4>{faq.question}</h4>
                <span className="faq-icon">
                  {openFaq === index ? "−" : "+"}
                </span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* DETAILED CONTACT FORM OR SUCCESS MESSAGE */}
      <section className="contact-section" id="contact">
        <div className="contact-card">
          <div className="contact-info-panel">
            <h3>Let's get to work.</h3>
            <p>
              Need a more detailed consultation? Fill out our full inquiry form
              or use the contact details below.
            </p>
            <div className="contact-details">
              <p>
                <strong>Phone</strong> 07540487647
              </p>
              <p>
                <strong>Email</strong> service@harveysgasandplumbing.co.uk
              </p>
            </div>
          </div>

          <div className="form-panel">
            {contactSuccess ? (
              <div className="inline-success" style={{ paddingTop: "3rem" }}>
                <div className="success-icon">&#10003;</div>
                <h3>Message Sent Successfully!</h3>
                <p>
                  Thank you {submittedContactName}. Your details have been
                  securely sent to our team, and we will be in touch shortly
                  regarding your project.
                </p>
                <button
                  className="btn-secondary"
                  onClick={() => setContactSuccess(false)}
                  style={{ borderColor: "#cbd5e1", color: "#0f172a" }}
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form onSubmit={handleContactSubmit}>
                <div className="input-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    value={contactForm.name}
                    onChange={(e) =>
                      setContactForm({ ...contactForm, name: e.target.value })
                    }
                    placeholder="e.g. John Smith"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    value={contactForm.phone}
                    onChange={(e) =>
                      setContactForm({ ...contactForm, phone: e.target.value })
                    }
                    placeholder="e.g. 07700 900077"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Service Type</label>
                  <select
                    value={contactForm.service}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        service: e.target.value,
                      })
                    }
                  >
                    <option value="Plumbing">Plumbing Repair</option>
                    <option value="Gas">Boiler & Gas Services</option>
                    <option value="Installation">New Installation</option>
                    <option value="Consultation">Site Consultation</option>
                  </select>
                </div>

                <div className="input-group">
                  <label>Project Details / Issue Description</label>
                  <textarea
                    value={contactForm.message}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        message: e.target.value,
                      })
                    }
                    placeholder="Please provide any additional details here..."
                    style={{
                      resize: "vertical",
                      width: "100%",
                      minHeight: "120px",
                      padding: "0.8rem",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn-primary"
                  style={{ marginTop: "1rem", padding: "1.15rem" }}
                  disabled={isSubmittingContact}
                >
                  {isSubmittingContact ? "Sending..." : "Submit Inquiry"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Dark Modern Footer */}
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>
              Harveys<span>.</span>
            </h3>
            <p>
              Your trusted experts for all premium plumbing and heating
              requirements.
            </p>
          </div>
          <div className="footer-socials">
            <div className="social-links"></div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Harveys Gas and Plumbing. All
            rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
